import { z } from 'zod';

/** `POST /jobs/:id/readiness/required-documents/:requiredDocumentTypeId/attachments` — tags an already-confirmed upload as this required document (gitaumoses4/chukua#36). */
export const attachRequiredDocumentSchema = z.object({
  uploadId: z.string().uuid(),
});
export type AttachRequiredDocumentInput = z.infer<typeof attachRequiredDocumentSchema>;

/** `POST /jobs/:id/readiness/override` — a supervisor override on one not-met readiness item, built on the generic override primitive. */
export const recordReadinessOverrideSchema = z.object({
  itemKey: z.string().trim().min(1).max(80),
  approverId: z.string().uuid(),
  reason: z.string().trim().min(1).max(500),
});
export type RecordReadinessOverrideInput = z.infer<typeof recordReadinessOverrideSchema>;
